// export const mode = process.env.NODE_ENV === 'production' ? 'hash' : 'history'
export const mode = process.env.NODE_ENV === 'production' ? 'hash' : 'hash'
